import 'ol/ol.css';

import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import View from 'ol/View';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import Overlay from 'ol/Overlay';
import {fromLonLat} from 'ol/proj';

const national_associations = [
    'bdp',
    'bmppd',
    'dpsg',
    'psg',
    'vcp',
    'vdapg'
];

map = new Map({
    target: "map",
    layers: [
        new TileLayer({
            source: new OSM()
        })
    ],
    view: new View({
        center: fromLonLat([10.00, 51.00]),
        zoom: 6
    }),
    allOverlays: true
});

national_associations.forEach(function(name){
    let layer = new WebGLPointsLayer({
        source: new VectorSource({
          // TODO: move into Typo3
          url: 'https://archiv.scoutnet.de/ausgabe.php?host=archiv.scoutnet.de&pfad=/ausgabe/geolocation_' + name + '.json',
          format: new GeoJSON(),
        }),
        style: {
          // TODO: generate asset location
          'icon-src': '/_assets/a7df236a13afef98d947a6880a982a4e/Images/' + name + '.png',
          'icon-width': 25,
          'icon-height': 25
        }
    });
    map.addLayer(layer);
});


let element = document.getElementById('popup');

let popup = new Overlay({
    element: element,
    positioning: 'bottom-center',
    stopEvent: false,
    offset: [0, -50],
});
map.addOverlay(popup);

// display popup on click
map.on('click', function (evt) {
    let feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
    });
    if (feature) {
        let content =
            feature.get('verband') + ' ' + feature.get('name') + '<br>' +
            feature.get('plz') + ' ' + feature.get('ort') + '<br>' +
            '<a href="' + feature.get('info_url')+ '">Mehr Informationen</a>';
        let coordinates = feature.getGeometry().getCoordinates();
        popup.setPosition(coordinates);
        $(element).popover({
            placement: 'top',
            html: true,
            content: content,
        });
        $(element).popover('show');
    } else {
        $(element).popover('dispose');
    }
});

// change mouse cursor when over marker
map.on('pointermove', function (e) {
    if (e.dragging) {
        $(element).popover('dispose');
        return;
    }
    let pixel = map.getEventPixel(e.originalEvent);
    let hit = map.hasFeatureAtPixel(pixel);

    let mapElement = document.getElementById(map.getTarget());
    mapElement.style.cursor = hit ? 'pointer' : '';
});
